module.exports = __webpack_public_path__ + "assets/img/account_code.5df8d50d.jpg";